<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels,Durareaders"></Breadcrumbs>
    <b-row class="image-slider-container">
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Digitally-printed graphics in a laminate substrate</div><br>
        <div>DuraReader CHPL signs are produced by digitally printing full-color graphics to paper. Then with heat,
          pressure, and phenolic resins, the graphics are pressed into the surface of a laminate substrate. An ultra-
          violet protective coating is also applied. DuraReader CHPL signs are widely used throughout the country
          and may be blind mounted or set in a frame (1/8," ½" thick, and optionally thicker).</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL01.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL02.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL03.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL04.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL05.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL06.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL07.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL08.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL09.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL10.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL11.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL12.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL13.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL14.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL15.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL16.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL17.jpg'),
          require('@/assets/images/pages/durareaders/duraReader-custom-high-pressure-laminate-CHPL18.jpg')
        ],
        type: Array
      }
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'DuraReader Custom High-pressure Laminate (CHPL)'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Durareaders.vue